import { createFileRoute } from '@tanstack/react-router';
import { NotificationsScreen } from '@/notifications/NotificationsScreen';

export const Route = createFileRoute('/_app/notifications/')({
  component: UnreadNotificationsRoute,
});

function UnreadNotificationsRoute() {
  return <NotificationsScreen />;
}

export default UnreadNotificationsRoute;
